import { useReducer, useEffect } from 'react';
import axios from 'axios';
import { apiReducer } from '../../reducers/apiReducer';

export const useApi = (url, initialData, refresh, enabled) => {

  const [state, dispatch] = useReducer(apiReducer, {
    data: initialData,
    isLoading: false,
    isError: false,
  });
 



  useEffect(() => {
  if (enabled === "not-enabled") {
    dispatch({ type: 'FETCH_DISABLED', payload: initialData });
    return;
  }
    let didCancel = false;

    const fetchData = async () => {
      dispatch({ type: 'FETCH_INIT' });

    
      try {
     
        const result = await axios(url, { withCredentials: true });
    
        if (!didCancel) {
         
          dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
        }
      } catch (error) {
        if (!didCancel) {
          // statut HTTP du refus, 0 si le serveur n'a pas répondu (réseau,
          // délai) : la projection l'affiche au lieu d'un écran vide
          dispatch({ type: 'FETCH_FAILURE', payload: { statut: error?.response?.status ?? 0 } });
        }
      }
    };

    fetchData();


  
 

    return () => {
      didCancel = true;
    };
  }, [url, refresh,enabled]);
  
  return state;
};